var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-outline/light-bulb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 24.6391V17.6391M16 17.6391C16.6906 17.6391 17.3608 17.5516 18 17.3871M16 17.6391C15.3094 17.6391 14.6392 17.5516 14 17.3871M19 27.3583C18.0283 27.5426 17.0254 27.6391 16 27.6391C14.9746 27.6391 13.9718 27.5426 13 27.3583M18 30.5351C17.3427 30.6038 16.6755 30.6391 16 30.6391C15.3245 30.6391 14.6573 30.6038 14 30.5351M19 24.6391V24.3835C19 23.073 19.8777 21.9524 21.0113 21.2947C23.9941 19.5641 26 16.3358 26 12.6391C26 7.11622 21.5228 2.63907 16 2.63907C10.4772 2.63907 6 7.11622 6 12.6391C6 16.3358 8.00594 19.5641 10.9887 21.2947C12.1223 21.9524 13 23.073 13 24.3835V24.6391",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/light-bulb.e5d39edfec5402db85f26a19d6804709.svg";
export { ForwardRef as ReactComponent };